import pako from "pako";

export function decompressCheckDoc(rawData) {
  const charData = atob(rawData)
    .split("")
    .map((x) => x.charCodeAt(0));
  const binData = new Uint8Array(charData);
  return JSON.parse(pako.inflate(binData, { to: "string" }));
}

export function decompressResultSummary(resultSummary) {
  const result = {};
  for (const key in resultSummary) {
    result[key] = decompressCheckDoc(resultSummary[key]);
  }
  return result;
}
